import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ErrorModal from './contexts/ErrorModal';

import AdminRoutes from './routes/AdminRoutes';
import VendorRoutes from './routes/VendorRoutes';
import ClientRoutes from './routes/ClientRoutes';

import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  // useEffect(() => {
  //   const host = window.location.hostname;

  //   const isAdmin = host === 'admin.yesppm.com';
  //   const isVendor = host === 'vendor.yesppm.com';
  //   const isClient = host === 'client.yesppm.com';

  //   const domainRoutes = {
  //     'admin.yesppm.com': '/admin/login',
  //     'vendor.yesppm.com': '/vendor/login',
  //     'client.yesppm.com': '/dashboard'
  //   };

  //   const route = domainRoutes[window.location.hostname] || '/login';

  //   if (window.location.pathname !== route && (isAdmin || isVendor || isClient)) {
  //     window.location.replace(route);
  //   }
  // }, []);

  const host = window.location.hostname;

  const isLocal =
    host === "localhost" ||
    host === "studio.yesppm.com" ||
    host === "127.0.0.1";

  const isAdmin = host === "admin.yesppm.com";
  const isVendor = host === "tenants.yesppm.com";
  const isClient = host === "portal.yesppm.com";

  console.log("==host==",host)

  return (
    <>
      <ErrorModal />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ThemeProvider>
            <Router>
              <Routes>
                {/* <Routes>
                {AdminRoutes()}
                {VendorRoutes()}
                {ClientRoutes()}
              </Routes> */}
                {isLocal && (
                  <>
                    {AdminRoutes()}
                    {ClientRoutes()}
                    {VendorRoutes()}

                  </>
                )}

                {isAdmin && AdminRoutes()}
                {isVendor && VendorRoutes()}
                {isClient && ClientRoutes()}
              </Routes>
            </Router>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </ThemeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;


// {isLocal && (
//   <>
//     <AdminRoutes />
//     <VendorRoutes />
//     <ClientRoutes />
//   </>
// )}

// {isAdmin && <AdminRoutes />}

// {isVendor && <VendorRoutes />}

// {isClient && <ClientRoutes />}

